var _path, _path2, _path3, _path4;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgIcnNavManageEtc = function SvgIcnNavManageEtc(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 40,
    viewBox: "0 0 41 40",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33 15.65V9.975C33 8.2125 32.2 7.5 30.2125 7.5H25.1625C23.175 7.5 22.375 8.2125 22.375 9.975V15.6375C22.375 17.4125 23.175 18.1125 25.1625 18.1125H30.2125C32.2 18.125 33 17.4125 33 15.65Z",
    stroke: "currentcolor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M33 29.7125V24.6625C33 22.675 32.2 21.875 30.2125 21.875H25.1625C23.175 21.875 22.375 22.675 22.375 24.6625V29.7125C22.375 31.7 23.175 32.5 25.1625 32.5H30.2125C32.2 32.5 33 31.7 33 29.7125Z",
    stroke: "currentcolor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.625 15.65V9.975C18.625 8.2125 17.825 7.5 15.8375 7.5H10.7875C8.8 7.5 8 8.2125 8 9.975V15.6375C8 17.4125 8.8 18.1125 10.7875 18.1125H15.8375C17.825 18.125 18.625 17.4125 18.625 15.65Z",
    stroke: "currentcolor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.625 29.7125V24.6625C18.625 22.675 17.825 21.875 15.8375 21.875H10.7875C8.8 21.875 8 22.675 8 24.6625V29.7125C8 31.7 8.8 32.5 10.7875 32.5H15.8375C17.825 32.5 18.625 31.7 18.625 29.7125Z",
    stroke: "currentcolor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIcnNavManageEtc, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icn_nav_manage_etc.3e2ae595.svg";
export { ForwardRef as ReactComponent };